/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  filteringOpen: true,
  legendOpen: true,
  sidebarInit: true
}

const getters = {
  
}
const actions = {

}
const mutations = {
  setFilteringOpen(state, { status }) {
    state.filteringOpen = !!status
  },
  setLegendOpen(state, { status }) {
    state.legendOpen = !! status
  },
  sidebarHasInit(state) {
    state.sidebarInit = false
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
